// Revenir en arrière / rétablir sur le planning. Le libellé en attente est privé : api.js le consomme via consommerLabel().
// Dernier planning connu, par planning : c'est le point de retour de « Revenir en arrière ». Il vit en mémoire.
window.__planningRefs = {};
window.planningRef = function(id) { return window.__planningRefs[id] != null ? window.__planningRefs[id] : null; };
window.setPlanningRef = function(id, json) { window.__planningRefs[id] = json; };

// --- REVENIR EN ARRIÈRE SUR LE PLANNING -----------------------------------------------------------------
// Chaque action qui modifie le planning empile l'état précédent avant de l'écraser. L'état empilé est le JSON
// déjà enregistré localement : une copie figée, insensible aux modifications faites SUR PLACE dans
// window.state.tasks (window.actions.toggleTask, par exemple, change le statut de l'objet lui-même).
// Seules les actions qui se déclarent par window.planningAction('…') sont empilées : les enregistrements
// techniques (nettoyage au démarrage, import d'un planning) ne polluent pas l'historique.
// L'historique est propre à chaque planning et survit à un rechargement de la page (localStorage).
var UNDO_KEY = 'edn_undo_v1';
var UNDO_MAX = 15;         // profondeur de l'historique EN MÉMOIRE
// Ce qui est réécrit dans le navigateur est bien plus petit : chaque état est une copie complète du planning
// (des centaines de kilo-octets sur un gros planning), le stockage ne fait que 5 Mo, et il compte deux octets
// par caractère. On n'y garde donc que les derniers états, et la copie du planning reste prioritaire sur eux.
var UNDO_MAX_PERSISTE = 4;
var UNDO_MAX_CARACTERES = 300000; // ≈ 600 Ko une fois stocké
var undoLabelEnAttente = '';

// À appeler juste avant un enregistrement du planning, avec ce que l'utilisateur vient de faire.
window.planningAction = function(label) { undoLabelEnAttente = label || 'Modification du planning'; };

window.undoStore = function() {
    if (!window.__undoStore) {
        var brut = null;
        try { brut = JSON.parse(localStorage.getItem(UNDO_KEY) || 'null'); } catch (e) { brut = null; }
        window.__undoStore = (brut && typeof brut === 'object') ? brut : {};
    }
    return window.__undoStore;
};
window.undoPiles = function(planningId) {
    var st = window.undoStore();
    var id = planningId || window.state.currentPlanningId || 'default';
    if (!st[id] || !Array.isArray(st[id].undo)) st[id] = { undo: [], redo: [] };
    if (!Array.isArray(st[id].redo)) st[id].redo = [];
    return st[id];
};
// Rend au navigateur la place prise par la copie de l'historique. L'historique EN MÉMOIRE n'est pas touché :
// annuler continue de marcher, c'est seulement la survie au rechargement qui est sacrifiée. Rend false quand
// il n'y avait rien à libérer.
window.undoLibererPlace = function() {
    try {
        if (!localStorage.getItem(UNDO_KEY)) return false;
        localStorage.removeItem(UNDO_KEY);
        return true;
    } catch (e) { return false; }
};
// L'historique complet vit en mémoire ; seuls les derniers états sont réécrits dans le navigateur, pour
// survivre à un rechargement sans dévorer la place dont la copie du planning a besoin.
window.undoSave = function() {
    var st = window.undoStore(), aEcrire = {};
    Object.keys(st).forEach(function(id) {
        aEcrire[id] = { undo: (st[id].undo || []).slice(-UNDO_MAX_PERSISTE), redo: (st[id].redo || []).slice(-UNDO_MAX_PERSISTE) };
    });
    for (var essai = 0; essai < 12; essai++) {
        var txt = JSON.stringify(aEcrire);
        if (txt.length <= UNDO_MAX_CARACTERES) { window.storageSet(UNDO_KEY, txt); return; }
        var vieux = null, cle = null;
        Object.keys(aEcrire).forEach(function(id) {
            ['undo', 'redo'].forEach(function(pile) {
                var e0 = (aEcrire[id][pile] || [])[0];
                if (e0 && (!vieux || e0.at < vieux.at)) { vieux = e0; cle = [id, pile]; }
            });
        });
        if (!cle) { try { localStorage.removeItem(UNDO_KEY); } catch (e) {} return; }
        aEcrire[cle[0]][cle[1]].shift();
    }
};
// Empile l'état précédent (JSON) ; appelée par syncWithServer avant d'écraser le planning.
window.undoPush = function(planningId, jsonPrecedent, label) {
    if (!jsonPrecedent) return;
    var p = window.undoPiles(planningId);
    p.undo.push({ label: label, at: Date.now(), tasks: jsonPrecedent });
    while (p.undo.length > UNDO_MAX) p.undo.shift();
    p.redo = []; // une nouvelle action rend le rétablissement caduc
    window.undoSave();
};
// Restaure un état sans l'empiler à son tour (aucun libellé en attente = aucun ajout à l'historique).
window.undoApply = function(tasks) {
    window.syncWithServer('save_tasks', { tasks: tasks, vider: !tasks.length }, function() { window.renderApp(); });
    window.renderApp();
};
// window.undoMessage appartient au toast du système (src/ui/components/toast.js), chargé après ce fichier : il
// l'y posait déjà, et la pastille grise que ce module dessinait — un div à classes Tailwind, sans mode nuit,
// hors du plan des toasts et non annoncée aux lecteurs d'écran — ne s'affichait jamais. Elle est partie au lot
// de clôture avec la dernière classe de palette du dossier src/core/. Les appels ci-dessous passent au toast.
window.actions.undoPlanning = function() {
    var p = window.undoPiles();
    if (!p.undo.length) { window.undoMessage('Rien à annuler'); return; }
    var e = p.undo.pop();
    p.redo.push({ label: e.label, at: Date.now(), tasks: JSON.stringify(window.state.tasks) });
    while (p.redo.length > UNDO_MAX) p.redo.shift();
    window.undoSave();
    window.undoApply(JSON.parse(e.tasks));
    window.undoMessage('Annulé : ' + e.label);
};
window.actions.redoPlanning = function() {
    var p = window.undoPiles();
    if (!p.redo.length) { window.undoMessage('Rien à rétablir'); return; }
    var e = p.redo.pop();
    p.undo.push({ label: e.label, at: Date.now(), tasks: JSON.stringify(window.state.tasks) });
    while (p.undo.length > UNDO_MAX) p.undo.shift();
    window.undoSave();
    window.undoApply(JSON.parse(e.tasks));
    window.undoMessage('Rétabli : ' + e.label);
};
// Ctrl/⌘ + Z pour annuler, Ctrl/⌘ + Maj + Z pour rétablir — jamais pendant une saisie (active recall,
// champs de texte), où le navigateur doit garder son propre annuler.
document.addEventListener('keydown', function(ev) {
    if (!(ev.ctrlKey || ev.metaKey) || ev.altKey) return;
    if (String(ev.key || '').toLowerCase() !== 'z') return;
    var t = ev.target || {};
    var tag = (t.tagName || '').toUpperCase();
    if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT' || t.isContentEditable) return;
    ev.preventDefault();
    if (ev.shiftKey) window.actions.redoPlanning(); else window.actions.undoPlanning();
});

// Le libellé déclaré par planningAction, consommé une seule fois par l'enregistrement qui suit.
export function consommerLabel() { var l = undoLabelEnAttente; undoLabelEnAttente = ''; return l; }
export function libelleEnAttente() { return undoLabelEnAttente; }

// Exports : les mêmes fonctions que celles posées sur window (le code historique les lit encore là).
export const planningRef = window.planningRef;
export const setPlanningRef = window.setPlanningRef;
export const planningAction = window.planningAction;
export const undoStore = window.undoStore;
export const undoPiles = window.undoPiles;
export const undoLibererPlace = window.undoLibererPlace;
export const undoSave = window.undoSave;
export const undoPush = window.undoPush;
export const undoApply = window.undoApply;
